var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7562 13.9875C16.8531 12.525 17.5 10.7125 17.5 8.75C17.5 3.925 13.575 0 8.75 0C3.925 0 0 3.925 0 8.75C0 13.575 3.925 17.5 8.75 17.5C10.7125 17.5 12.525 16.85 13.9875 15.7562L17.8656 19.6344C18.1094 19.8781 18.4281 20 18.75 20C19.0719 20 19.3906 19.8781 19.6344 19.6344C20.1219 19.1469 20.1219 18.3562 19.6344 17.8656L15.7562 13.9875ZM8.75 15C5.30312 15 2.5 12.1969 2.5 8.75C2.5 5.30312 5.30312 2.5 8.75 2.5C12.1969 2.5 15 5.30312 15 8.75C15 12.1969 12.1969 15 8.75 15Z",
    fill: "#0D1D6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.120cf0c71db88592a1ba9e737234d5ac.svg";
export { ForwardRef as ReactComponent };